import CreateAssociation from './CreateAssociation.page';

export default CreateAssociation;